import styled from 'styled-components';

export const Select = styled.select`
  height: 51px;
  width: 304px;
  text-align: center;
  border: 1px solid;
`;
